<div class="modal-container">

	<ib-generic-header
		[headerModel]="headerModel"
		[imgUrl]="imgUrl"
		[iconUrl]="iconUrl"
		(closeModal)="goBackMMB()">
	</ib-generic-header>

	<!-- body -->
	<main class="ib-layout">
		<!-- End wrapper-->
		<section class="container">
			<!-- Main content-->
			<div class="row">
				<div class="ib-table-row u-mt-big">
					<div class="col-xs-12 col-lg-8">
						<h1 class="ib-heading ib-heading--type-1 u-mb-xsmall">{{'SEATS_DISRUPTION_TITLE' | translate}}</h1>
						<h1 class="ib-text ib-text--block ib-text--medium u-mt-xsmall">{{'SEATS_DISRUPTION_SUBTITLE' | translate}}</h1>
						<h1 class="ib-heading ib-heading--type-2 u-mt-medium">{{'SEATS_DISRUPTION_ALTERNATIVES' | translate}}</h1>
						<ib-disrupted-seat-option-one
							[model]="model">
						</ib-disrupted-seat-option-one>

						<ib-disrupted-seat-option-two
							[flowId]="flowId"
							(openSeatmap)="openSeatMapDisruptedSegment($event)">
						</ib-disrupted-seat-option-two>

						<ib-disrupted-seat-option-three
							[flowId]="flowId"
							[creationDate]="creationDate">
						</ib-disrupted-seat-option-three>
					</div>
					<div class="col-xs-12 col-lg-4">
						<div class="row ib-box-info--equal-height">
							<ib-box-info class="col-xs-12 col-sm-6 col-lg-12" *ngFor="let infoBox of boxInfoModels"
								[boxInfoModel]="infoBox">
							</ib-box-info>
						</div>
					</div>
				</div>
			</div>
		</section>
	</main>
	<!-- end body -->


	<ib-generic-footer
		[iconUrl]="iconUrl">
	</ib-generic-footer>

</div>
